import React from 'react';
import { Button, Modal, ButtonToolbar, Row, Col, FormGroup } from 'reactstrap';
import Select from 'react-select';
import classNames from 'classnames';
import { map } from 'lodash'

const ModalReasingSharp = (props) => {
  const { color, title, colored, header, isOpen: modal, toggle, values, onwer, executives, onChange, loadingReasing } = props;

  const modalClass = classNames({
    'modal-dialog--colored': colored,
    'modal-dialog--header': header,
  });

  return (
    <div>
      <Modal
        isOpen={modal}
        toggle={toggle()}
        className={`modal-dialog--${color} ${modalClass}`}
        style={{ maxWidth: '70%' }}
      >
        <div className="modal__header">
          <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle()} />
          {header}
          <h2 className="bold-text  modal__title" style={{ textAlign: 'left', padding: '0px 15px' }}>{title}</h2>
        </div>
        <br />
        <div className="modal__body">
          <Row>
            <Col md={6}>
              <div style={{ borderRight: '2px solid #dee2e66b', height: '100%' }}>
                <Row>
                  <Col md={7} style={{ textAlign: 'left' }}>
                    <h4 className="label_autofin">Casos:</h4>
                  </Col>
                </Row>
                {map(values, (e, index) => {
                  return (
                    <Row key={index}>
                      <Col md={7} style={{ textAlign: 'left' }}>
                        <span style={{ margin: '3px 0px' }}>
                          <strong style={{ margin: '0px 5px' }}>ID:</strong>
                          {e.code}
                        </span>
                      </Col>
                    </Row>
                  );
                })}
              </div>
            </Col>
            <Col md={3} style={{ textAlign: 'left' }}>
              <FormGroup style={{ borderRight: '2px solid #dee2e66b', height: '100%' }}>
                <h4 className="label_autofin">Ejecutivo actual:</h4>
                <span>{onwer}</span>
              </FormGroup>
            </Col>
            <Col md={3} style={{ textAlign: 'left' }}>
              <FormGroup>
                <h4 className="label_autofin">Ejecutivo a transferir casos:</h4>
                <Select
                  options={executives}
                  type="text"
                  name="executive"
                  placeholder="seleccione"
                  id="executive"
                  onChange={onChange('executiveSelected')}
                  required
                />
              </FormGroup>
            </Col>
          </Row>
        </div>
        <ButtonToolbar className="modal__footer" style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={toggle()} style={{ backgroundColor: '#ffff' }}>
            Cancelar
          </Button>{' '}
          <Button className="asignar just_this" onClick={toggle(true)} disabled={loadingReasing}>
            Transferir
          </Button>
        </ButtonToolbar>
      </Modal>
    </div>
  );
}

export default ModalReasingSharp;